const hasIdentity = value => value !== null && typeof value !== 'undefined' && value !== ''

const normalizePositiveInteger = value => {
    const normalized = Number(value)

    return Number.isInteger(normalized) && normalized > 0 ? normalized : null
}

const getAcceptedSubstanceIds = (links) => Array.from(new Set(
    (Array.isArray(links) ? links : [])
        .filter(link => link && link.status === 'accepted')
        .map(link => normalizePositiveInteger(link.substanceId))
        .filter(Boolean),
))

const buildSubstanceRegulationProjection = ({ substances, links, resolutionItems }) => {
    const factsByExtractedId = (Array.isArray(substances) ? substances : []).reduce((result, substance) => {
        if (substance && hasIdentity(substance.extractedSubstanceId)) {
            result[String(substance.extractedSubstanceId)] = substance
        }

        return result
    }, {})
    const resolutionBySubstanceId = (Array.isArray(resolutionItems) ? resolutionItems : [])
        .reduce((result, item) => {
            const substanceId = normalizePositiveInteger(item && item.substanceId)
            if (substanceId) {
                result[String(substanceId)] = Array.isArray(item.regulations) ? item.regulations : []
            }

            return result
        }, {})
    const byId = {}
    const byKey = {}
    const assignedRows = new Set()

    ;(Array.isArray(links) ? links : []).forEach((link, linkIndex) => {
        if (!link || link.status !== 'accepted' || !hasIdentity(link.extractedSubstanceId)) {
            return
        }

        const substanceId = normalizePositiveInteger(link.substanceId)
        const extractedSubstanceId = String(link.extractedSubstanceId)
        const substance = factsByExtractedId[extractedSubstanceId]
        if (!substanceId || !substance) {
            return
        }

        const regulations = resolutionBySubstanceId[String(substanceId)] || []
        regulations.forEach(regulation => {
            if (!regulation) {
                return
            }

            const regulationId = normalizePositiveInteger(regulation.id)
            const regulationKey = typeof regulation.key === 'string' ? regulation.key : ''
            const rowIdentity = `${extractedSubstanceId}:${substanceId}`
            const assignmentIdentity = `${regulationId || regulationKey}:${rowIdentity}`

            if (assignedRows.has(assignmentIdentity)) {
                return
            }
            assignedRows.add(assignmentIdentity)

            const row = {
                rowKey: `related-substance-${rowIdentity}-${linkIndex}`,
                extractedSubstanceId,
                substanceId,
                substance,
            }

            if (regulationId) {
                byId[String(regulationId)] = (byId[String(regulationId)] || []).concat(row)
            }
            if (regulationKey) {
                byKey[regulationKey] = (byKey[regulationKey] || []).concat(row)
            }
        })
    })

    return { byId, byKey }
}

const getRelatedSubstances = (projection, regulation) => {
    if (!projection || !regulation) {
        return []
    }

    const regulationId = normalizePositiveInteger(regulation.id)
    if (regulationId && projection.byId && projection.byId[String(regulationId)]) {
        return projection.byId[String(regulationId)]
    }

    return regulation.key && projection.byKey
        ? projection.byKey[regulation.key] || []
        : []
}

export {
    buildSubstanceRegulationProjection,
    getAcceptedSubstanceIds,
    getRelatedSubstances,
}
